



















































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { AssetClass3, AssetClassesApi } from 'performo-api';
import { mapGetters } from 'vuex';
import { handleApiError } from '@/ApiHelpers';

@Component({
  computed: mapGetters({
    api: 'assetClassesApi'
  })
})
export default class AssetClass3Picker extends Vue {
  @Prop({ required: false, default: 'asset-class-3-picker' })
  private id?: string;

  @Prop({ required: false, default: false, type: Boolean })
  private required?: boolean;

  @Prop({ required: false, default: false, type: Boolean })
  private hideAll?: boolean;

  @Prop({ required: false, default: false, type: Boolean })
  private hideLabel?: boolean;

  @Prop({ required: true })
  private value!: string;

  @Prop({ required: false, default: 'Function' })
  private labelOverride?: string;

  @Prop({ required: false, default: undefined })
  private assetClass2?: string;

  @Prop({ required: false, default: undefined })
  private assetClass1?: string;

  get getValue() {
    return this.value;
  }

  get sortedClasses() {
    return this.classes.sort((a, b) => {
      if (!a.assetClass3Name || !b.assetClass3Name) return 0;
      var nameA = a.assetClass3Name.toUpperCase(); // ignore upper and lowercase
      var nameB = b.assetClass3Name.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      // names must be equal
      return 0;
    });
  }

  private api!: AssetClassesApi;
  private classes: AssetClass3[] = [];
  private loadingClasses = false;
  private hasMounted = false;

  @Watch('assetClass1')
  private resetValue() {
    if (this.hasMounted) {
      this.$emit('input', undefined);
    }
  }

  @Watch('assetClass2')
  private async loadClasses() {
    this.resetValue();
    if (this.assetClass2 && this.assetClass2 != '*') {
      this.loadingClasses = true;
      try {
        this.classes = await this.api.assetClass3Query({
          assetClass2Name: this.assetClass2
        });
        this.loadingClasses = false;
        return this.classes;
      } catch (error) {
        this.loadingClasses = false;
        return handleApiError(error);
      }
    } else {
      this.classes = [];
    }
  }

  private async mounted() {
    await this.loadClasses();
    this.hasMounted = true;
  }
}
